import { createAction, props } from '@ngrx/store';
import {
    AMSubmittalJob,
    SubmittalVendorInfo,
    SubmittalDataSummary
} from 'src/app/accountmanagers/submittals/model/am-submittals.model';
import { JobForSubmittal } from 'src/app/accountmanagers/submittals/model/job-for-submittal.model';
import { SubmittalRemovalReason } from 'src/app/accountmanagers/submittals/model/submittal-removal-reasons.model';
import { WorkforceDisruptionFacilityPlacement } from 'src/app/workforce-disruption/shared/models/workforce-disruption-facility-placement.model';
import { JobGridLookups } from 'src/app/shared/models/job-grid-lookups';
import { SubmittalStatus } from 'src/app/shared/models/submittal-status.model';
import { AccountManagerDashboardAlert } from 'src/app/accountmanagers/dashboard/models/account-manager-dashboard.model';
import { AmSubmittalsBulkRemove } from 'src/app/accountmanagers/submittals/model/am-submittals-bulk-remove.model';
import { UpdateWfdPriorityDto } from 'src/app/shared/models/wfd-priority.model';

export const amSubmittalReassign = createAction(
    '[AM Submittal Reassign API] Reassign Submittals',
    props<{ submittalData: SubmittalDataSummary[]; accountManagerId: number; fromAccountManagerId: number }>()
);

export const amSubmittalReassignSuccess = createAction(
    '[AM Submittal Reassign API] Reassign Submittals Success',
    props<{ result: boolean }>()
);

export const amSubmittalReassignFailure = createAction(
    '[AM Submittal Reassign API] Submittal Reassign Failure',
    props<{ error: any }>()
);

export const amLoadJobsLookups = createAction('[ACCOUNT MANAGER JOBS COMPONENT] Load Jobs Lookups');

export const amLoadJobsLookupsSuccess = createAction(
    '[ACCOUNT MANAGER API] Load Jobs Lookups Success',
    props<{ lookups: JobGridLookups }>()
);

export const amLoadJobsLookupsFail = createAction(
    '[ACCOUNT MANAGER API] Load Jobs Lookups Fail',
    props<{ error: unknown }>()
);

export const amLoadJobsForSubmittals = createAction(
    '[ACCOUNT MANAGER SUBMITTALS COMPONENT] Load Jobs For Submittals',
    props<{ submittalIds: number[] }>()
);

export const amJobsForSubmittalsLoaded = createAction(
    '[ACCOUNT MANAGER SUBMITTALS COMPONENT] Jobs For Submittals are loaded',
    props<{ jobs: JobForSubmittal[] }>()
);

export const amJobsForSubmittalsFail = createAction(
    '[ACCOUNT MANAGER SUBMITTALS COMPONENT] Jobs For Submittals failed to load',
    props<{ error: unknown }>()
);

export const amSubmittalJobsLoaded = createAction(
    '[ACCOUNT MANAGER SUBMITTAL JOBS COMPONENT] Submittal Jobs are loaded',
    props<{ jobs: AMSubmittalJob[] }>()
);

export const amSendEmails = createAction(
    '[ACCOUNT MANAGER JOBS COMPONENT] Send Emails to recruiters',
    props<{
        jobIds: number[];
        apnSubject: string;
        apnBody: string;
        ayaSubject: string;
        ayaBody: string;
        sendTo: 'All' | 'Placed' | 'Submitted';
    }>()
);

export const amLoadOfferRecruiters = createAction('[ACCOUNT MANAGER SUBMITTAL JOBS API] Load Offer Recruiters');

export const amLoadOfferRecruitersSuccess = createAction(
    '[ACCOUNT MANAGER SUBMITTAL JOBS API] Load Offer Recruiters Success',
    props<{ recruiterIds: number[] }>()
);

export const amLoadOfferRecruitersError = createAction(
    '[ACCOUNT MANAGER SUBMITTAL JOBS API] Load Offer Recruiters Error',
    props<{ error: unknown }>()
);

export const amLoadSubmittalRemovalReasons = createAction(
    '[ACCOUNT MANAGER REMOVE FROM LIVE LIST DIALOG COMPONENT] Load Submittal Removal Reasons'
);

export const amLoadSubmittalRemovalReasonsSuccess = createAction(
    '[ACCOUNT MANAGER REMOVE FROM LIVE LIST DIALOG COMPONENT] Load Submittal Removal Reasons Success',
    props<{ submittalRemovalReasons: SubmittalRemovalReason[] }>()
);

export const amLoadSubmittalRemovalReasonsFail = createAction(
    '[ACCOUNT MANAGER REMOVE FROM LIVE LIST DIALOG COMPONENT] Load Submittal Removal Reasons failed to load',
    props<{ error: unknown }>()
);

export const amBulkRemoveFromLiveList = createAction(
    '[ACCOUNT MANAGER REMOVE FROM LIVE LIST DIALOG COMPONENT] Bulk Remove From Live List',
    props<{ submittalJobs: AmSubmittalsBulkRemove }>()
);

export const amBulkRemoveFromLiveListSuccess = createAction(
    '[ACCOUNT MANAGER REMOVE FROM LIVE LIST DIALOG COMPONENT] Bulk Remove From Live List Success'
);

export const amBulkRemoveFromLiveListFail = createAction(
    '[ACCOUNT MANAGER REMOVE FROM LIVE LIST DIALOG COMPONENT] Bulk Remove From Live List Fail',
    props<{ error: unknown }>()
);

export const resetBulkRemoveFromLiveListResult = createAction(
    '[ACCOUNT MANAGER BULK REMOVE FROM LIVE LIST DIALOG COMPONENT]  Reset Remove From Live List Result '
);

export const getVendorInfoForSubmittals = createAction(
    '[ACCOUNT MANAGER LIVE LIST COMPONENT] Load Vendor Info For Submittals',
    props<{ userId: number }>()
);

export const getVendorInfoForSubmittalsSuccess = createAction(
    '[ACCOUNT MANAGER LIVE LIST API] Load Vendor Info For Submittals Success',
    props<{ vendorInfo: SubmittalVendorInfo[] }>()
);

export const getVendorInfoForSubmittalsFailure = createAction(
    '[ACCOUNT MANAGER LIVE LIST API] Load Vendor Info For Submittals Failure',
    props<{ error: unknown }>()
);

export const getFacilityPlacement = createAction(
    '[WFD BOOKED CANDIDATES PLACEMENTS COMPONENT] Load Selected Facility Placement Candidate Ids',
    props<{ facilityPlacement: WorkforceDisruptionFacilityPlacement }>()
);

export const getSubmittalStatuses = createAction('[AM SUBMITTALS DETAILS GRID COMPONENT] Load Submittal Statuses');

export const getSubmittalStatusesSuccess = createAction(
    '[ACCOUNT MANAGER SERVICE] Load Submittal Statuses Success',
    props<{ statuses: SubmittalStatus[] }>()
);

export const getSubmittalStatusesFailure = createAction(
    '[ACCOUNT MANAGER SERVICE] Load Submittal Statuses Failure',
    props<{ error: unknown }>()
);

export const accountManagerDashboardAlertSuccess = createAction(
    '[HUB CONNECTION SERVICE] Account Manager Dashboard Alert Success',
    props<{ data: AccountManagerDashboardAlert }>()
);

export const accountManagerDashboardAlertFailure = createAction(
    '[HUB CONNECTION SERVICE] Account Manager Dashboard Alert Failure',
    props<{ error: unknown }>()
);

export const updateWfdPriority = createAction('[AM Submittals LL] Update WFD Priority', props<UpdateWfdPriorityDto>());
